
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"52","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"52","height":"52","rx":"26","fill":"#F0F4FA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26 35.6a9.6 9.6 0 009.6-9.6 9.6 9.6 0 10-9.6 9.6zm3.676-13.717l-5.475 5.434-1.816-1.792a1.332 1.332 0 00-1.87 1.896l2.84 2.806a1.2 1.2 0 001.69-.003l6.494-6.466a1.322 1.322 0 00-1.863-1.875z","fill":"#525F7F"}})])
          )
        }
      }
    